import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-modal-page__wrap"
}
const _hoisted_2 = { class: "ui-modal-page__header" }
const _hoisted_3 = { class: "ui-modal-page__in" }
const _hoisted_4 = { class: "ui-modal-page__content" }

import { ref, onUnmounted, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiModalPage',
  props: {
  modelValue: Boolean,
},
  emits: ["update:modelValue", "open", "close"],
  setup(__props, { emit }) {

const props = __props





const show = ref(false);
const showContainer = ref(false);

watch(
  () => props.modelValue,
  (value) => (value ? open() : close())
);

watch(
  () => show.value,
  () => emit("update:modelValue", show.value)
);

function open() {
  show.value = true;
  emit("open");
  document.body.style.overflow = "hidden";
}

function close() {
  showContainer.value = false;
  document.body.style.overflow = "auto";
}

function handleEnter() {
  showContainer.value = true;
}

function handleLeave() {
  show.value = false;
  emit("close");
}

onUnmounted(() => {
  document.body.style.overflow = "auto";
});

const modalAnimation = window.innerWidth < 768 ? "slide-top" : "fade-bottom";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      onEnter: _cache[2] || (_cache[2] = ($event: any) => (handleEnter())),
      appear: "",
      name: "ffff"
    }, {
      default: _withCtx(() => [
        (show.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (close()), ["self"])),
              class: "ui-modal-page"
            }, [
              _createVNode(_Transition, {
                onLeave: _cache[0] || (_cache[0] = ($event: any) => (handleLeave())),
                name: _unref(modalAnimation)
              }, {
                default: _withCtx(() => [
                  (showContainer.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                          _renderSlot(_ctx.$slots, "header")
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _renderSlot(_ctx.$slots, "default")
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              }, 8, ["name"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})